var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M10 0H3.33333C1.33333 0 0 1 0 3.33333V8C0 10.3333 1.33333 11.3333 3.33333 11.3333H10C12 11.3333 13.3333 10.3333 13.3333 8V3.33333C13.3333 1 12 0 10 0ZM10.3133 4.06L8.22667 5.72667C7.78667 6.08 7.22667 6.25333 6.66667 6.25333C6.10667 6.25333 5.54 6.08 5.10667 5.72667L3.02 4.06C2.80667 3.88667 2.77333 3.56667 2.94 3.35333C3.11333 3.14 3.42667 3.1 3.64 3.27333L5.72667 4.94C6.23333 5.34667 7.09333 5.34667 7.6 4.94L9.68667 3.27333C9.9 3.1 10.22 3.13333 10.3867 3.35333C10.56 3.56667 10.5267 3.88667 10.3133 4.06Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }